// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608111146/js/" + chunkId + "." + {"44":"eaebb08c","225":"d0f91551","481":"638279a9","486":"0a7acf66","770":"4074da6d"}[chunkId] + ".0.5057474229898952.chunk.js";
};